import { FleetManagementRow, FleetManagementRowValues } from "../types/FleetManagement-row.types";

/**
 * creates the newly created fleet data and assembles a fleet item object
 */
export function mapNewRowToPartialFleetItem(
  values: FleetManagementRowValues
): Partial<FleetManagementRow> {
  return {
    id: values.id,
    name: values.name,
    description: values["description"],
    location: {
      id: values["location.id"],
      name: values["location.name"]
    },
    companyId: values.companyId ?? null,
    companyName: values.companyName ?? null,
    fleetPermissions: values.fleetPermissions,
    picturePaths: values.picturePaths,
    licensePlate: values.licensePlate,
    brandModel: values.brandModel,
    vehicleType: values.vehicleType,
    fuel: values.fuel,
    reach: values.reach,
    numSeats: values.numSeats,
    pricePerHour: values.pricePerHour,
    bufferMinutes: values.bufferMinutes,
    properties: values.properties,
    status: values.status,
    blockedReason: values.blockedReason,
    odometer: values.odometer,
    adminNotes: values.adminNotes,
    userNotes: values.userNotes,
    contractDetails: values.contractDetails,
    attachments: values.attachments
  };
}
